import React from "react";

import { Close } from "@mui/icons-material";
import { Card, IconButton, Modal, ModalProps } from "@mui/material";

const VideoModal = ({ children, onClose, ...props }: ModalProps) => {
  return (
    <Modal {...props} onClose={onClose}>
      <>
        <Card
          sx={{
            width: "100%",
            maxWidth: "1200px",
            height: "auto",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {children}
        </Card>
        <IconButton
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            bgcolor: "none",
            "&:hover": {
              bgcolor: "#FFFFFF80",
            },
          }}
          onClick={(e) => onClose && onClose(e, "backdropClick")}
        >
          <Close sx={{ fill: "#FFF", width: "40px", height: "40px" }} />
        </IconButton>
      </>
    </Modal>
  );
};

export default VideoModal;
